export const EVENT_LOAD_SUCCESS = 'event/LOAD_SUCCESS';
export const EVENT_CREATE_SUCCESS = 'event/CREATE_SUCCESS';
export const EVENT_EDIT_SUCCESS = 'event/EDIT_SUCCESS';
export const EVENT_CHANGE_FEATURED_SUCCESS = 'event/CHANGE_FEATURED_SUCCESS';
export const EVENT_CHANGE_STARRED_SUCCESS = 'event/CHANGE_STARRED_SUCCESS';
export const EVENT_DELETE_SUCCESS = 'event/DELETE_SUCCESS';
export const SPECIAL_SAVE = 'special/SAVE';
export const SPECIAL_SET_LOADING = 'special/LOADING';
export const SPECIAL_UNSET_LOADING = 'special/UNSET_LOADING';
